import _slicedToArray from "/home/shipsy/crm-logistics-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export function parseAABB(min2) {
  var min = min2.min,
    max = min2.max;
  return [[min[0], min[1]], [max[0], max[1]]];
}
/**
 * Whether the `point` in `bounds`.
 * @param point
 * @param bounds
 */
export function isInBounds(point, bounds) {
  var _point = _slicedToArray(point, 2),
    x = _point[0],
    y = _point[1];
  var _bounds = _slicedToArray(bounds, 2),
    min = _bounds[0],
    max = _bounds[1];
  return x >= min[0] && x <= max[0] && y >= min[1] && y <= max[1];
}
/**
 * Whether `b1` is overflow from `b2`.
 * @param b1
 * @param b2
 */
export function isOverflow(b1, b2) {
  var _b = _slicedToArray(b1, 2),
    min = _b[0],
    max = _b[1];
  return !(isInBounds(min, b2) && isInBounds(max, b2));
}
/**
 * Whether `b1` is overlap with `b2`.
 * @param b1
 * @param b2
 * @returns
 */
export function isOverlap(b1, b2) {
  var _b2 = _slicedToArray(b1, 2),
    min1 = _b2[0],
    max1 = _b2[1];
  var _b3 = _slicedToArray(b2, 2),
    min2 = _b3[0],
    max2 = _b3[1];
  return min1[0] < max2[0] && max1[0] > min2[0] && min1[1] < max2[1] && max1[1] > min2[1];
}